import React, { Fragment, useState } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faAlignJustify, faUpload } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedFuncionariosScreen() {
    const [cad, setCad] = useState(false)
    const [listar, setListar] = useState(false)
    const [importar, setImportar] = useState(false)
    if (listar) {
        return <Navigate to={{ pathname: '/rh/funcionarios/listar' }} />
    }

    if (cad) {
        return <Navigate to={{ pathname: '/rh/funcionarios/cadastrar' }} />
    }

    if (importar) {
        return <Navigate to={{ pathname: '/rh/funcionarios/importar' }} />
    }

    return (
        <Fragment>
            <Container>
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Cadastrar Funcionário</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Listar Funcionários</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setImportar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faUpload} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Importar Funcionários em Massa</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                    <Fragment>
                        <br /><br />
                        <Link to={'/rh'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment>
            </Container>
        </Fragment>
    );
}

export default HomeLoggedFuncionariosScreen;